// src/locales/zh.ts — Chinese (Simplified)
import type { TranslationKey } from './en'

const zh: Record<TranslationKey, string> = {
  // Navigation
  'nav.dashboard': '\u4eea\u8868\u76d8',
  'nav.tests': '\u6d4b\u8bd5',
  'nav.sat': 'SAT',
  'nav.psat': 'PSAT',
  'nav.act': 'ACT',
  'nav.practice': '\u7ec3\u4e60',
  'nav.learn': '\u5b66\u4e60',
  'nav.videos': '视频',
  'nav.bookmarks': '\u4e66\u7b7e',
  'nav.pricing': '\u4ef7\u683c',
  'nav.groups': '\u5c0f\u7ec4',
  'nav.signIn': '\u767b\u5f55',
  'nav.signOut': '\u9000\u51fa',

  // Dashboard
  'dashboard.welcomeBack': '\u6b22\u8fce\u56de\u6765',
  'dashboard.scorePrediction': '\u5206\u6570\u9884\u6d4b',
  'dashboard.studyPlan': '\u5b66\u4e60\u8ba1\u5212',
  'dashboard.quickDrill': '\u5feb\u901f\u7ec3\u4e60',
  'dashboard.inviteFriends': '\u9080\u8bf7\u597d\u53cb',

  // Common
  'common.start': '\u5f00\u59cb',
  'common.resume': '\u7ee7\u7eed',
  'common.retake': '\u91cd\u65b0\u6d4b\u8bd5',
  'common.submit': '\u63d0\u4ea4',
  'common.next': '\u4e0b\u4e00\u9898',
  'common.previous': '\u4e0a\u4e00\u9898',
  'common.cancel': '\u53d6\u6d88',
  'common.save': '\u4fdd\u5b58',
  'common.loading': '\u52a0\u8f7d\u4e2d',

  // Results
  'results.score': '\u5206\u6570',
  'results.correct': '\u6b63\u786e',
  'results.incorrect': '\u9519\u8bef',
  'results.time': '\u65f6\u95f4',
  'results.viewResults': '\u67e5\u770b\u7ed3\u679c',
  'results.downloadPdf': '\u4e0b\u8f7dPDF',
  'results.share': '\u5206\u4eab',

  // Practice
  'practice.byTopic': '\u6309\u4e3b\u9898\u7ec3\u4e60',
  'practice.checkAnswer': '\u68c0\u67e5\u7b54\u6848',
  'practice.explanation': '\u89e3\u6790',

  // Pricing
  'pricing.freePlan': '\u514d\u8d39\u8ba1\u5212',
  'pricing.proPlan': 'PRO\u8ba1\u5212',
  'pricing.upgrade': '\u5347\u7ea7',
  'pricing.monthly': '\u6bcf\u6708',
  'pricing.testsPerMonth': '\u6bcf\u6708\u6d4b\u8bd5\u6b21\u6570',
  'pricing.unlimited': '\u65e0\u9650',

  // Language selector
  'language.label': '\u8bed\u8a00',
}

export default zh
